<template>
    <svg :class="className" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 224.9 35.2" style="enable-background:new 0 0 224.9 35.2;" xml:space="preserve">
    <g id="logo-g">
        <polygon class="st0" points="169.1,18 169.1,12 174.3,15 179.5,18 174.3,21 169.1,23.9"/>
        <circle class="st1" cx="47.2" cy="17.7" r="5.2"/>
        <path class="st2" d="M221.2,33.6L201,6.1v27.5h-2.7v-32h2.8l20.1,27.1V1.6h2.7v32H221.2z"/>
        <path class="st2" d="M173.2,34.7c-9.3,0-16.8-7.5-16.8-16.8s7.5-16.8,16.8-16.8S190,8.6,190,17.9C189.9,27.2,182.4,34.6,173.2,34.7
            z M173.2,3.8c-7.7,0-14,6.3-14,14s6.3,14,14,14s14-6.3,14-14l0,0C187.2,10.1,180.9,3.9,173.2,3.8z"/>
        <path class="st2" d="M145.5,33.6l-9-13.2h-7v13.2h-2.7v-32h12c5.5,0,9.7,3.5,9.7,9.3c0.2,4.9-3.5,9-8.4,9.2c-0.2,0-0.3,0-0.5,0
            l9.2,13.4L145.5,33.6L145.5,33.6z M145.5,11c0.1-3.7-2.8-6.7-6.5-6.9c-0.2,0-0.4,0-0.6,0h-9v13.8h9c3.7,0.2,6.9-2.5,7.1-6.2
            C145.5,11.4,145.5,11.2,145.5,11L145.5,11z"/>
        <path class="st2" d="M106.7,33.6V4.1H96.2V1.6h23.7v2.5h-10.4v29.5H106.7z"/>
        <path class="st2" d="M72.6,33.6v-32h20.3v2.5H75.3v11.8h17.2v2.5H75.3v15.1L72.6,33.6L72.6,33.6z"/>
        <path class="st2" d="M47.2,34.6c-9.3,0-16.8-7.5-16.8-16.8S37.9,1,47.2,1S64,8.5,64,17.8C63.9,27,56.5,34.5,47.2,34.6z M47.2,3.7
            c-7.7,0-14,6.3-14,14s6.3,14,14,14s14-6.3,14-14l0,0C61.2,10,55,3.7,47.2,3.7z"/>
        <path class="st2" d="M1,29.1L2.8,27c2.5,2.9,6.1,4.6,10,4.6c6.6,0,8.4-3.6,8.4-6.4c0-4.5-4.3-5.7-8.8-6.9C7.4,17,2,15.5,2,9.6
            c0-5.2,4.7-8.5,10.5-8.5c4.1-0.2,8,1.5,10.8,4.5l-1.8,2c-2.3-2.7-5.6-4.2-9.2-4C8,3.6,4.8,6,4.8,9.5c0,3.8,4,4.9,8.4,6
            C18.4,17,24,18.6,24,25.1c0,4.1-2.7,9.1-11.4,9.1C8.2,34.3,3.9,32.4,1,29.1z"/>
    </g>
    </svg>
</template>

<script setup>
// --- IMPORTS ---
import { toRefs } from 'vue'

// --- PROPS ---
const props = defineProps({
    className: {
      type: String,
      default: "",
    }
})
const { className } = toRefs(props)
</script>

<style scoped>
    .st0 {
        fill:#1B75BB;
    }
    .st1 {
        fill:#FF4300;
    }
    .st2 {
        fill:var(--theme-font-color);
    }
</style>